import { useQuery } from '@tanstack/react-query';
import fetchWrapper from '@http/fetchWrapper';
import { api } from '@http/constants';

export const useDomainActions = () => {
  const domainAction = useQuery({
    queryKey: [api.i18nDomain],
    staleTime: 1000 * 60 * 60 * 24,
    queryFn: () =>
      fetchWrapper.get(api.i18nDomain) as Promise<{
        locales: string[];
        namespaces: string[];
        translatorEngines: string[];
      }>,
  });

  return {
    domainAction,
  };
};
